import { SgDateUtil, SgNumberUtil } from 'saga-modules';
import { LocalDateUtil } from 'gw-portals-util-js';
import _ from 'lodash';
import CommonAdobeAnalyticsUtil from './CommonAdobeAnalyticsUtil';

const MALE_PREFIXES = ['mr'];
const FEMALE_PREFIXES = ['mrs', 'ms', 'miss'];

const COMMON_TAGGING_PROPERTIES = {
    BHpremiumPageAction: { id: 'BHpremiumPageAction' },
    BHquoteJourney: { id: 'BHquoteJourney' },
    BHquoteType: { id: 'BHquoteType' },
    BHtrafficType: { id: 'BHtrafficType' },
    loginStatus: { id: 'loginStatus' },
    addOnsArray: { id: 'addOnsArray' },
    addedProductsArray: { id: 'addedProductsArray' },
    dateOfBirth: {
        id: 'age',
        transform: (date) => {
            if (_.isObject(date)) {
                return date.day && date.monthViewValue && date.year ? SgDateUtil.calcAge(LocalDateUtil.toMidnightDate(date)) : undefined;
            }
            return date;
        }
    },
    aggPriceChangeMsgClicked: { id: 'aggPriceChangeMsgClicked' },
    aggPriceChangeDifference: { id: 'aggPriceChangeDifference' },
    clickThroughId: { id: 'clickThroughId' },
    periodStartDate: {
        id: 'coverStartDate',
        transform: (date) => ((date.day && date.monthViewValue && date.year)
            // dd/MM/yyyy
            ? `${SgNumberUtil.add0Padding(date.day)}/${SgNumberUtil.add0Padding(date.monthViewValue)}/${date.year}`
            : undefined),
        dependent: ['numberOfDaysTillCoverStart']
    },
    ctaText: { id: 'ctaText' },
    defaqtoInsurerSelect: { id: 'defaqtoCompare' },
    gdprReconsentVariant: { id: 'gdprReconsentVariant' },
    genderPolicyHolder: {
        id: 'gender',
        transform: (value) => {
            return CommonAdobeAnalyticsUtil.getTypelistValue('GenderType', value);
        },
        getValue: (prefix) => {
            if (_.includes(MALE_PREFIXES, prefix.code || prefix)) {
                return CommonAdobeAnalyticsUtil.getTypelistValue('GenderType', 'M');
            }
            if (_.includes(FEMALE_PREFIXES, prefix.code || prefix)) {
                return CommonAdobeAnalyticsUtil.getTypelistValue('GenderType', 'F');
            }
            return '';
        }
    },
    numberOfDaysTillCoverStart: {
        id: 'numberOfDaysTillCoverStart',
        getValue: (source) => (_.isObject(source) && !_.isEmpty(source) ? SgDateUtil.dateDiffInDays(new Date(), source) : undefined)
    },
    partTimeOccupationPolicyHolder: { id: 'partTimeOrVoluntaryWork' },
    pncdEligible: { id: 'pncdEligible' },
    postalCode: {
        id: 'postcode',
        transform: (value) => value.replace(/\s/g, '').toUpperCase()
    },
    postDocumentsCheckbox: { id: 'postDocumentsCheckbox' },
    homeAddressListLength: { id: 'addressListLength' },
    productCategory: { id: 'productCategory' },
    productName: { id: 'productName' },
    quoteFieldError: { id: 'quoteFieldError' },
    quoteNumber: { id: 'quoteNumber' },
    quoteSection: { id: 'quoteSection' },
    removedProductsArray: { id: 'removedProductsArray' },
    retrievalFailure: { id: 'retrievalFailure' },
    scid: { id: 'scid' },
    titlePolicyHolder: {
        id: 'title',
        transform: (value) => {
            return CommonAdobeAnalyticsUtil.getTypelistValue('NamePrefix', value);
        },
        dependent: ['genderPolicyHolder']
    },
    trustPilotClicked: { id: 'trustPilotClicked' },
    trustPilotEncryptedValue: { id: 'trustPilotEncryptedValue' },
    compulsoryExcess: { id: 'compulsoryExcess' },
    voluntaryExcessError: { id: 'voluntaryExcessError' },
    phoneNumber: {
        id: 'phoneNumber',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    phoneModalOpened: { id: 'phoneModalOpened' },
    chatOpened: { id: 'chatOpened' },
    expiredQuoteRetrieval: { id: 'expiredQuoteRetrieval' },
    mvtTests: { id: 'mvtTests' },
    fieldErrorArray: { id: 'fieldErrorArray' },
    paymentPlan: {
        id: 'paymentPlan',
        transform: (isAnnual) => (isAnnual ? 'annualPaymentPlan' : 'monthlyPaymentPlan')
    },
    paymentAutoRenewal: { id: 'paymentAutoRenewal' },
    premiumPageAccordion: { id: 'premiumPageAccordion' },
    premiumPageSubAccordion: { id: 'premiumPageSubAccordionOpened' },
    annualPriceCostChange: { id: 'annualPriceCostChange' },
    monthlyPriceCostChange: { id: 'monthlyPriceCostChange' },
    membershipClicked: { id: 'membershipClicked' },
    monthlyPriceDisplayed: { id: 'monthlyPriceDisplayed' },
    changePaymentDetailsCepBillingPageIsDisabled: { id: 'changePaymentDetailsCepBillingPageIsDisabled' },
};

export default COMMON_TAGGING_PROPERTIES;
